/**
 * Chat History Item Styled Components
 */

import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';

// History Item Container
export const HistoryItemContainer = styled.button<{ $isActive: boolean }>`
  width: 100%;
  padding: 8px;
  margin-bottom: 2px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: ${({ $isActive, theme }) =>
    $isActive ? (theme as IOcAppTheme).color.secondaryBG || OcColors.bg2 : 'transparent'};
  text-align: left;
  font-size: ${({ theme }) => theme.font.size.default};
  font-weight: ${({ theme, $isActive }) => ($isActive ? theme.font.weight.semiBold : theme.font.weight.regular)};
  color: ${({ theme, $isActive }) => ($isActive
    ? (theme as IOcAppTheme).color.textSecondary || OcColors.defaultText
    : (theme as IOcAppTheme).color.textPrimary || OcColors.defaultText)};

  &:hover, &:focus {
    background-color: ${({ theme }) => (theme as IOcAppTheme).color.secondaryBG || OcColors.bg2};
    color: ${({ theme }) => (theme as IOcAppTheme).color.textSecondary || OcColors.defaultText}
  }
`;

// History Item Content Wrapper
export const HistoryItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// History Item Label
export const HistoryItemLabel = styled.div<{ $isActive: boolean }>`
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

